module.exports = __webpack_public_path__ + "static/media/groomingPageGentleIcon.03fcb72e.png";